// Tekster for pipeline pakke 5 (Lead inn: hurtigregistrering, duplikatsjekk,
// kvalifisering, diskvalifisering og leads i «Å gjøre»). Egen fil så delene
// av pakken kan bygges hver for seg.
export const norwegianPipelineLeadMessages = {
  crm: {
    deals: {
      lead: {
        new_title: "Ny lead",
        new_description: "Registrer en henvendelse. Den havner i Lead inn.",
        name: "Navn",
        phone: "Telefon",
        email: "E-post",
        company: "Firma (valgfritt)",
        org_nr: "Org.nr.",
        need: "Behov",
        source_label: "Kilde",
        source_line: "Kilde: %{source}",
        referred_by: "Anbefalt av",
        note: "Notat (valgfritt)",
        save: "Lagre lead",
        created: "Leaden er registrert i Lead inn",
        default_next: "Ring tilbake",
        note_fallback: "Ny henvendelse",
        note_added: "Lagt til på eksisterende mulighet: %{title}",
        brreg_search: "Slå opp i Brønnøysund",
        brreg_hits: "Treff i Brønnøysund",
        brreg_none: "Ingen treff",
        not_a_lead: "Ikke en lead",
        no_contact: "Ingen kontakt logget",
        lost_banner:
          "Tapt mulighet på samme kunde: %{name} (for %{time} siden).",
        lost_banner_no_date: "Tapt mulighet på samme kunde: %{name}.",
        lost_advice_new: "Over 6 uker siden: vi anbefaler en ny mulighet.",
        lost_advice_ask:
          "Under 6 uker siden: gjenåpne hvis det gjelder samme behov.",
        lost_new: "Ny mulighet",
        lost_linked: "Leaden er en ny mulighet, lenket til %{name}",
        flag: {
          parse_failed: "Kunne ikke tolke skjemaet – sjekk",
          unverified_sender: "Ikke verifisert avsender",
        },
        source: {
          manual: "Manuell",
          prospect: "Prospektering",
          web_form: "Nettskjema",
          email: "E-post",
          phone: "Telefon",
          referral: "Anbefaling",
          upsell: "Eksisterende kunde (mersalg)",
          other: "Annet",
        },
        dup: {
          none: "Nei",
          checking: "Sjekker …",
          hint: "Skriv e-post, telefon eller firma, så sjekker vi om vi kjenner dem.",
          open_deal: "Finnes allerede: %{title}",
          open: "Åpne muligheten",
          add_note: "Legg til notat i stedet",
          lost_deal: "Tapt mulighet: %{title}.",
          lost_hint:
            "Under 6 uker siden og samme behov: gjenåpne den. Ellers lagrer vi en ny mulighet.",
          see_lost: "Se den tapte",
          customer_badge: "Eksisterende kunde",
          customer_hint:
            "Kilden blir «Eksisterende kunde (mersalg)», og kundeansvarlig blir eier.",
          use: "Bruk",
          use_named: "Bruk %{name}",
          used: "Brukes",
          match: {
            email: "e-post",
            phone: "telefon",
            org_nr: "org.nr.",
            domain: "domene",
            name: "navn",
          },
        },
      },
      qualify_dialog: {
        title: "Kvalifiser %{name}",
        description:
          "Leaden flyttes til %{stage}. Notater, filer og oppgaver følger med.",
        points: "Sjekkpunkter",
        point: {
          need: "Behov",
          budget: "Budsjett",
          timeline: "Tidsramme",
          decision_maker: "Beslutningstaker",
        },
        service: "Tjeneste (behov)",
        budget_range: "Budsjettramme",
        choose_service: "Velg tjeneste …",
        need_service: "Velg tjenesten kunden trenger.",
        one_time: "Engangsverdi (anslag)",
        monthly: "Månedlig verdi (anslag)",
        need_value: "Anslå verdien, engangs eller månedlig.",
      },
      disqualify: {
        reason: "Årsak",
        choose_reason: "Velg årsak …",
        need_reason: "Velg en årsak.",
        comment: "Kommentar (valgfritt)",
      },
      table: {
        source: "Kilde",
      },
    },
    dashboard: {
      today: {
        group: {
          lead_parse_failed: "Kunne ikke tolke skjemaet",
          leads_no_contact: "Leads uten kontakt",
        },
      },
    },
  },
};

export const englishPipelineLeadMessages = {
  crm: {
    deals: {
      lead: {
        new_title: "New lead",
        new_description: "Register an enquiry. It lands in the inbox stage.",
        name: "Name",
        phone: "Phone",
        email: "Email",
        company: "Company (optional)",
        org_nr: "Org. no.",
        need: "Need",
        source_label: "Source",
        source_line: "Source: %{source}",
        referred_by: "Referred by",
        note: "Note (optional)",
        save: "Save lead",
        created: "The lead is registered in the inbox",
        default_next: "Call back",
        note_fallback: "New enquiry",
        note_added: "Added to existing opportunity: %{title}",
        brreg_search: "Look up in the business register",
        brreg_hits: "Business register results",
        brreg_none: "No results",
        not_a_lead: "Not a lead",
        no_contact: "No contact logged",
        lost_banner:
          "Lost opportunity for the same customer: %{name} (%{time} ago).",
        lost_banner_no_date: "Lost opportunity for the same customer: %{name}.",
        lost_advice_new:
          "More than 6 weeks ago: we recommend a new opportunity.",
        lost_advice_ask:
          "Less than 6 weeks ago: reopen it if it is the same need.",
        lost_new: "New opportunity",
        lost_linked: "The lead is a new opportunity, linked to %{name}",
        flag: {
          parse_failed: "Could not read the form – check",
          unverified_sender: "Unverified sender",
        },
        source: {
          manual: "Manual",
          prospect: "Prospecting",
          web_form: "Web form",
          email: "Email",
          phone: "Phone",
          referral: "Referral",
          upsell: "Existing customer (upsell)",
          other: "Other",
        },
        dup: {
          none: "No",
          checking: "Checking …",
          hint: "Type an email, phone or company and we check whether we know them.",
          open_deal: "Already exists: %{title}",
          open: "Open the opportunity",
          add_note: "Add a note instead",
          lost_deal: "Lost opportunity: %{title}.",
          lost_hint:
            "Less than 6 weeks ago and the same need: reopen it. Otherwise we save a new opportunity.",
          see_lost: "See the lost one",
          customer_badge: "Existing customer",
          customer_hint:
            "The source becomes “Existing customer (upsell)”, and the account manager becomes owner.",
          use: "Use",
          use_named: "Use %{name}",
          used: "In use",
          match: {
            email: "email",
            phone: "phone",
            org_nr: "org. no.",
            domain: "domain",
            name: "name",
          },
        },
      },
      qualify_dialog: {
        title: "Qualify %{name}",
        description:
          "The lead moves to %{stage}. Notes, files and tasks come along.",
        points: "Checkpoints",
        point: {
          need: "Need",
          budget: "Budget",
          timeline: "Timeline",
          decision_maker: "Decision maker",
        },
        service: "Service (need)",
        budget_range: "Budget range",
        choose_service: "Choose service …",
        need_service: "Choose the service the customer needs.",
        one_time: "One-time value (estimate)",
        monthly: "Monthly value (estimate)",
        need_value: "Estimate the value, one-time or monthly.",
      },
      disqualify: {
        reason: "Reason",
        choose_reason: "Choose reason …",
        need_reason: "Choose a reason.",
        comment: "Comment (optional)",
      },
      table: {
        source: "Source",
      },
    },
    dashboard: {
      today: {
        group: {
          lead_parse_failed: "Could not read the form",
          leads_no_contact: "Leads without contact",
        },
      },
    },
  },
};
